import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useArena } from "core/components/ArenaProvider";
import usePageview from "core/hooks/usePageview";
import ContentHelmet from "arena/components/ContentHelmet";
import ShortyVirtualFeed from "./ShortyVirtualFeed";

export default function Shorty({ params: { contentId } }) {
  const arena = useArena();
  const [helmetContent, setHelmetContent] = useState(null);
  const location = useLocation();

  usePageview(location.pathname, helmetContent?.title);

  return (
    <>
      <ContentHelmet arena={arena} content={helmetContent} />
      <ShortyVirtualFeed
        initialContentId={contentId}
        onHelmetContentChange={setHelmetContent}
      />
    </>
  );
}

Shorty.propTypes = {
  params: PropTypes.shape({
    contentId: PropTypes.string.isRequired,
  }),
};
